<template>
  <div class="issue-table">
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="data"
      :columns="tableColumns"
      size="small"
      height="350"
      resizable
      border
    >
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('tips_no_data') || '暂无数据' }}</p>
        </div>
      </template>
      
      <template v-slot:operation="{ row, rowIndex }">
        <el-button
          v-if="!disabled"
          type="text"
          size="small"
          style="color: #f56c6c"
          @click="handleDelete(row, rowIndex)"
        >
          {{ $l('btn_delete') || '删除' }}
        </el-button>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  name: 'IssueTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tableColumns() {
      return [
        {
          type: 'seq',
          title: this.$l('table_label_index') || '#',
          width: 60,
          align: 'center'
        },
        {
          field: 'defectIssuesTitle',
          title: this.$l('table_label_major_issue') || '重大问题',
          align: 'center',
          minWidth: 200,
          formatter: ({ row }) => this.formatIssueTitle(row)
        },
        {
          field: 'operation',
          title: this.$l('table_label_operation') || '操作',
          width: 100,
          align: 'center',
          slots: { default: 'operation' }
        }
      ]
    }
  },
  methods: {
    formatIssueTitle(row = {}) {
      const title = (row.defectIssuesTitle || '').trim()
      const otherProblemDesc = `${row.otherProblemDesc || ''}`.trim()
      if (title === '其他' && otherProblemDesc) {
        return `${title}：${otherProblemDesc}`
      }
      return title
    },
    handleDelete(row, index) {
      this.$emit('delete', { row, index })
    }
  }
}
</script>

<style lang="scss" scoped>
.issue-table {
  width: 50%;
  
  .no-data {
    margin-top: 10px;
    font-size: 14px;
    color: #909399;
  }
}
</style>
